module.exports = __webpack_public_path__ + "static/media/locker.9c580951.jpg";